// ======================================================================
// 📁 File: EquipmentKpiBar.jsx
// 📝 Purpose:
//   Equipment Master KPI Cards
// ======================================================================

import React from "react";

export default function EquipmentKpiBar({
  rows = []
}) {

  const totalEquipment =
    rows.length;

  const activeEquipment =
    rows.filter(
      (r) => r.is_active
    ).length;

  const inactiveEquipment =
    rows.filter(
      (r) => !r.is_active
    ).length;

  const mappedEquipment =
    rows.filter(
      (r) => r.product_variant_id
    ).length;

  const cards = [
    {
      title: "Total Equipment",
      value: totalEquipment
    },
    {
      title: "Active",
      value: activeEquipment
    },
    {
      title: "Inactive",
      value: inactiveEquipment
    },
    {
      title: "Mapped to Variant",
      value: mappedEquipment
    }
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit, minmax(220px,1fr))",
        gap: 12,
        marginBottom: 18
      }}
    >

      {cards.map((card) => (

        <div
          key={card.title}
          className="card shadow-sm border-0"
        >

          <div className="card-body">

            <div
              style={{
                fontSize: 13,
                color: "#6b7280"
              }}
            >
              {card.title}
            </div>

            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                marginTop: 6
              }}
            >
              {card.value}
            </div>

          </div>

        </div>

      ))}

    </div>
  );
}